export const sortedNotificationKairon = [{ topic: 'armReminder', text: 'KaironNotifications.ArmReminder' }];

export const sortedNotificationMaia = [{ topic: 'fenceReminder', text: 'MaiaNotifications.GeolocatedActivation' }];
